export const environment = {
  production: false,
  base_graphql: "https://linea-service.duka.dev/graphql",
  base_url: "https://linea-service.duka.dev/v1",
  client_id: 'a37e38b9-7729-43b3-99c5-c2456d36f8ce',
  tenant_id: '3c815d0f-7a6b-457e-8bfd-d5b195a5425c',
  base_link: 'https://linea-admin.duka.dev',
  base_socket: 'https://linea-service.duka.dev',
};
